import { fetchWithTimeout } from '../utils';
import { analyticsUrl } from './fetchClient';

interface RequestProps {
  id: string | string[];
  type: 'view' | 'cart' | 'share' | 'favorite' | 'rate';
  impressions: string[];
}

export const sendAnalytics = async (
  data: RequestProps,
  xRequestId: string | null,
  timeout: number = 3000,
) => {
  try {
    const response = fetchWithTimeout(analyticsUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      timeout: timeout,
      body: JSON.stringify({
        requestId: xRequestId,
        class: 'recommend',
        ...data,
      }),
    }).then((res) => res.json());
    return response;
  } catch {
    // TODO: Handle error
  }
};
